import { render, staticRenderFns } from "./practice-analysis.vue?vue&type=template&id=02010614&scoped=true"
import script from "./practice-analysis.vue?vue&type=script&lang=js"
export * from "./practice-analysis.vue?vue&type=script&lang=js"
import style0 from "./practice-analysis.vue?vue&type=style&index=0&id=02010614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02010614",
  null
  
)

export default component.exports